// extracted by mini-css-extract-plugin
export var mainBanner = "mainBanner-module--mainBanner--MDZ1-";
export var button = "mainBanner-module--button--XBxEU";
export var header = "mainBanner-module--header--j9vle";
export var subHeader1 = "mainBanner-module--subHeader1--ezzcK";
export var subHeader2 = "mainBanner-module--subHeader2--0s-sr";